module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NEESA")]), _vm._v(" A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("DANI")])]), _vm._v(" was stuck in a waking nightmare. She battled a surge of panic as her younger sister and aunts led her forward towards the place where her fiancé waited to make her his wife.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The elaborate wedding sari she wore constricted her movements, adding to the sense of cloying claustrophobia. Heavy jewels literally dripped from her head, ears, throat, arms and hands, weighing her down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fighting an overwhelming urge to break free and escape she told herself once again that she only had herself to blame for her predicament. If she hadn’t been so blinkered, so unforgivably naïve…so impossibly complacent, then she might not be here right now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was propelled forward again and suddenly her fiancé and her parents saw her arrival. A hush descended over the crowd in the huge and beautiful inner courtyard, lit with the seductive glow of hundreds of lanterns. This courtyard was the centrepiece in one of the most exclusive hotels in Mumbai—the jewel in the hotel’s crown. The sheer opulence of it all terrified her now, the reality of what she was doing hitting her anew.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("With an awful sick feeling of impending doom and ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("fatality Aneesa reluctantly moved forward, but just then a small movement caught her eye from the side. She glanced around and, for a moment, was blinded by the icy blue gaze of a man. He was slightly obscured, in the shadows, but even that couldn’t hide the fact that he was so tall and good-looking he momentarily distracted her from her surroundings.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she registered the darkly handsome foreigner who had no doubt snuck in to ogle the most prestigious wedding of the year, reality slammed back into her again, heightened now by seeing him—as if he represented some kind of escape or freedom to her. And she knew in that moment that she hadn’t been able to disguise the fear or turmoil in her eyes. He’d seen it all and she could only be thankful that he was a complete stranger. Tearing her eyes away, she mentally steeled herself and walked forward to meet her fate….")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Sebastian Wolfe still reeled slightly from the searing glance he’d shared with the bride as she’d arrived. She’d looked around only briefly and yet had honed in on his gaze as if she’d felt the weight of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged off the prickling sensation. He had to admit that he didn’t think he’d ever seen a more beautiful bride. He smiled cynically—not that he ever had any intention of watching one walk down an aisle towards "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v(". Coming from a large family of mainly half-siblings, having been born to a man who’d married three times, had numerous affairs and begat eight children, to say that Sebastian had a jaundiced view of the holy sanctity of marriage was a huge understatement.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("With an iron will, he concentrated once more on his surroundings and not the potential minefield of his ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("family, who had dispersed from their ancestral home, Wolfe Manor, as soon as they’d been able to escape.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the huge and ornately decorated inner courtyard a stunning marquee covered in silken swathes of material took up the centre space under a dusky evening sky. The bride, while being of average height, stood with a regal and graceful bearing that made her appear taller.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her face was a smooth mask of intent concentration, and given the elaborate ritual of the traditional Indian wedding, he couldn’t blame her. It seemed to him to consist of a dizzying array of minutely observed events, each as important as the last and all following a strict code. It had been going on for days now, culminating in this ceremony here tonight. Incense was burning, ladening the warm air around him with a rich and luxuriant smell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A short while before, Sebastian had watched the arrival of the groom carried aloft on a gold chair, where, bedecked in a long tunic of spun silken gold and close-fitting matching trousers, he’d been greeted by his in-laws, his face obscured by a curtain of fresh marigold flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then the bride had been brought in, her slender arms encased in silver, red and gold bangles, led by attendant women. Sebastian had seen the intricate henna tattoo that adorned her hands up as far as her lower arms. In her glittering red-and-gold sari and elaborate headdress and with a pearl-and-diamond jewel nestling at the centre of her forehead, she’d looked like an Indian princess from the Mogul Empire.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("The memory of the look they’d shared hit him again with a jolt of sensation in his solar plexus. It was bizarre, ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("but he thought he’d seen something close to panic and desperation in her huge brown, heavily kohled eyes.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He frowned; he must have been mistaken, because now, as he watched the bride and groom place garlands over each other’s heads, she looked nothing but serene. And yet, had he just seen her delicate hands shaking? Sebastian mentally chastised himself—what did he care for the emotional state of a complete stranger on her wedding day? All he cared about was that everything went smoothly and they had no cause to fault their venue.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This hotel was just one in his hugely successful chain of hotels around the world. The uberluxurious Mumbai Grand Wolfe Hotel. And he was here merely on a whirlwind tour to oversee the society wedding of the year: Aneesa Adani to Jamal Kapoor Khan, two of Bollywood’s hottest stars.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From the report his Indian PA had given him about the wedding, he knew that Aneesa Adani had been crowned Miss India some years before and following a successful modelling career she’d branched into Bollywood movies and had since become their biggest star, with a veritable list of number-one movies to her credit. The subsequent romance and wedding with fellow Bollywood star Jamal Kapoor Khan was going to make them the power couple of Indian cinema for years to come. They were at the very epicentre of mass adulation, which in a country of more than a billion people was no small feat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Sebastian cast a quick look around, noting to his satisfaction the heavily armed security guards and plain-clothed police officers, amongst his own highly trained security team. Nothing had been left to chance and he ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("was quietly confident of the strict security measures and discretion he could guarantee in all of his hotels. It was one of the reasons his hotel had been picked as the venue of choice for this wedding as well as for its ultralavish yet understated stylish surroundings.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("From where he stood he could see the rising moon shining over the Arabian Sea and the floodlit outline of the Gateway of India, Mumbai’s most iconic landmark.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sebastian waited for the usual sense of satisfaction to steal over him when he experienced a moment like this—the rare chance to stand back and survey his hard work. A moment when he lifted his head long enough to acknowledge the fruits of his success. But it didn’t come. And it was only then that he realised that he hadn’t felt it in some time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unused to and slightly disturbed by that thought and the impulse to self-examine which he didn’t usually indulge in, he looked once again to the centre of the marquee where the bride and groom now sat side by side on regal thrones on a raised dais.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bride’s exquisite face was still a cool mask of serenity but Sebastian felt the hairs rise on the back of his neck as if he could somehow sense that it was just a façade.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then he felt a pull of something much more earthy in his groin. Encased in the elaborate wedding costume he could only see snatches of her pale olive skin, an enticing view of the bare curve of her waist and top of her hip below the tight bodice. He could imagine the silky texture of that skin, that it would feel as soft as a fresh rose petal.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("To his utter chagrin and disgust, Sebastian realised ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("that he was ogling a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bride")]), _vm._v(" in the midst of her wedding ceremony and that merely looking at her was arousing him to a level that he hadn’t felt since his last liaison had ended some weeks previously. He realised, too, that on some very base level he felt "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("jealous")]), _vm._v(" of the groom, that he would be the one to uncover the lush secrets of his new wife’s exotic beauty.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sebastian cursed himself. He’d no doubt that Aneesa Adani was like every other girl of her upper-middle-class upbringing. A little princess. Her marriage to this man was merely the next step in a life of luxury and inherent idleness, despite her career as an actress. And he’d no doubt, too, that she would be no blushing virgin on her wedding night. Despite the chaste lovemaking of the Bollywood movies, in the real world the stars were just as amoral and prone to bed-hopping as in Hollywood, and she’d had a highly publicised relationship with this man for months.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Despite those assertions, turning away took more effort than he liked to acknowledge and he saw one of his close aides waiting patiently in the wings for his next move. Sebastian welcomed the distraction and thrust aside disturbing thoughts of flashing kohled eyes that had emitted what must have been an imaginary beacon of distress, and equally disturbing erotic images of sensual half-hidden curves.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("He walked out of the courtyard, leaving the wedding behind, and smiled grimly. His mind had been playing tricks on him, perhaps the ritual and incense had gotten to him for a moment. Striding across the main reception area which was a glorious fusion of classic Moorish and Portuguese design, he coolly ignored the admiring looks his tall and powerful frame drew. The ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("attention of women was something that Sebastian and his brothers had never had to worry about. They’d effortlessly drawn it as soon as they’d been old enough to know what that attention meant.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Minutes later, after consulting with his hotel manager, he stepped into his private lift and felt the habitual constriction of being in a suit, and the familiar need to engage in something physical which would clear and quieten his mind. Exercise for Sebastian was a drug, an outlet he’d turned to for as long as he could remember. It had helped him escape the chaos of his dysfunctional upbringing and now helped him escape the rigid confines on his time. It also eased the niggling sense of dissatisfaction he increasingly felt, and helped him through the frequent nights where he was lucky to get three hours sleep, the curse of the chronic insomniac.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sebastian didn’t register the impassive lines of his hard-boned face in the mirrored elevator door; he’d long ago learnt the art of projecting a controlled front, even while inwardly he might be a mass of contradictions. But his thoughts helplessly veered back to the couple downstairs. He had no doubt that in time reality would strike and the sham that all marriages inevitably were would become apparent in theirs. And in a country which held one of the lowest divorce rates in the world he could almost feel a twinge of sympathy for the happy couple, for it was unlikely they’d be allowed to escape the confines of their union, especially if they had children.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He chastised himself mockingly—who was he to rain on their parade or judge them? His mouth tightened with grim black humour—after all, hadn’t he himself come from a far from normal family upbringing?")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On that thought the elevator doors opened and Sebastian walked into the penthouse Grand Wolfe suite, the best in the hotel. As he started to rip off his tie and jacket he mentally wished the couple downstairs all the best in the world and firmly pushed the image of the luscious bride from his mind. They were welcome to each other and a lifetime of wedded disharmony.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Aneesa was barely aware of the wedding ritual going on around her. She felt numb from the inside out and she knew on some level that this feeling was a form of self-protection, albeit dangerously flimsy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her head ached as it had done ever since her comfortable, privileged and secure world had been blown to smithereens just two evenings previously. She’d gone to Jamal’s rooms at the hotel to surprise him, hoping that she might encourage him to take their chaste lovemaking to the next level.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The thought of being a virgin on her wedding night had inexplicably filled Aneesa with fear; perhaps even then she’d been aware that what she and Jamal shared wasn’t normal and had wanted to provoke him in some way. She’d never understood his reticence in the physical side of their relationship.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But instead of finding him quietly reading his new script, which is what he’d told her he’d be doing, she’d found him in bed. With his assistant. His "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("male")]), _vm._v(" assistant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Aneesa knew she still hadn’t fully assimilated the shock of that moment. She’d stumbled to the bathroom and had been violently ill. By then Jamal’s lover had disappeared and Jamal had calmed down enough to go into damage limitation mode.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She could remember his smoothly handsome face, a mask of condescending pity, as he’d asked her how she hadn’t already known about this when all their friends knew. And Aneesa had almost been sick again when she’d recalled the snide looks she’d often dismissed as petty jealousy from their circle of friends. She’d also had to acknowledge uncomfortably that of her so-called friends who even now thronged the courtyard of this exclusive hotel, there hadn’t been one she’d felt she could confide in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It had been a harsh pill to swallow to acknowledge how shallow her life had become, and how easily she’d left good friends behind once she’d become more and more famous.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the space of that one evening, her whole life had undergone a subtle but seismic shift. And in the couple of days since, Aneesa had changed from being a relatively spoilt young woman, who’d pretty much taken everything around her for granted, into someone more mature and less naïve. The urge to find comfort in blame had been futile, for she knew she was as much to blame for the situation she now found herself in, as painful as it was to acknowledge that.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Jamal’s curt warning from that evening still rang in her ears and it had fatally inhibited her impulse to ask for help or advice: ‘If you think for a second that you can walk away from this marriage you can kiss your career goodbye for ever. Who would want to marry you after such a scandal? Because you can be sure of one thing, if you walk away and try to save face by telling people the truth, I will deny it and fight you every step of the way. This marriage is my ticket to respectability for ever. Our children will make everyone believe that ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("we have the perfect marriage. And who would even believe you over me? Their beloved Jamal Kapoor Khan?’")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Aneesa had known he was right. If she even attempted to reveal the truth she’d be crucified by his millions of devoted fans. As famous as she was, he was a far bigger star. She’d be a pariah and would never make another movie in India. Apart from all of that, she was the first in her family to get married. Her beloved paternal grandmother was nearing ninety and maintaining that she was clinging onto dear life just long enough to see Aneesa wed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Aneesa also knew that while the public perception of her family was that they had untold wealth, in fact, her father had been struggling to keep the family silk business afloat for some time now. Only she and her mother knew the reality, which was that this wedding was all but crippling her father financially.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And yet, Aneesa also knew that her father would prefer to face financial ruin than the ignomy of not being able to pay for his first daughter’s marriage. He was so proud that he hadn’t even let Aneesa help financially. While her pay packet was nothing like her Hollywood counterparts, by Indian standards she was a wealthy woman in her own right.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And how could she have told her parents about Jamal’s secret? They were conservative and solidly middle class. Respectability was their middle name; they would be devastated. The pressure in her head and behind her eyes suddenly increased now in an intense physical pain.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("She could feel the weight of Jamal’s gaze from her left and could barely bring herself to turn to him, ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("anticipating all too well the false adoration that would be written all over his handsome features. It was a look that he’d perfected over many years in films. A look that she’d fallen for herself when they’d met on her first film, and a look that she’d fooled herself into believing was sincere.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No wonder he’d wooed her so easily, she recognised now with acrid bitterness. He’d seen her coming from a mile away: sheltered, spoilt, immature and unbelievably naïve. And she’d fallen for his act, hook, line and sinker—seduced by his smooth good looks and even smoother talking. Not to mention his intense attention and adulation of her. He’d appealed to all the worst parts of her and she’d live with the shame of that for the rest of her life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her train of thought and self-disgust was cut short abruptly when the priest officiating indicated for them to stand. They were approaching the most sacred part of the ceremony, after which Aneesa knew her chances of escape would be all but gone for ever.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The ends of her sari and Jamal’s long jacket were tied together and they were about to walk around the sacred fire seven times, while seven blessings were said, each one for different aspects of their marriage. As they started to walk slowly around the fire, Aneesa felt again the rising tide of panic. The numbness was leaving her now and in its place she began to shake and tremble in reaction to what she was doing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Any girlish dreams she’d had of falling in love and marrying had long since been turned to dust. Her eyes were wide open now and with each step she took with Jamal around this fire, she was hurtling further into a future with no escape and certain pain and suffering. ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("How could she possibly bring children into a marriage like that? When their father would be sleeping with their mother purely to procreate and maintain a façade?")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In that second Aneesa recalled the piercing blue eyes of the man she’d seen in the shadows and suddenly an impulse stronger than anything she’d ever felt rushed through her. In the midst of the shock and panic she acted with an economy and sureness of movement that surprised her. She stopped and bent and swiftly undid the knot that tied her sari to Jamal’s coat. She barely heard his indrawn breath and his hissed, ‘Aneesa…what do you think you are doing?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then she stepped off the dais. Heart thumping she went straight to her open-mouthed father and took his hand in hers. She was aware that everyone was frozen in shock and surprise and knew dimly that she had to take advantage of that. She brought her father’s hand to her mouth and pressed a kiss against it and said with a hoarse voice, her eyes filling with tears, ‘I’m so sorry, Papa, I can’t do this. I’ll pay you back. Please forgive me.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And she fled.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Aneesa was barely aware of where she’d run, she knew only that she wouldn’t have long to capitalise on the shock of the wedding crowd before her father sent people to find her. She couldn’t bear to think of her parents’ confusion and dismay either, or else she’d falter altogether. And she couldn’t turn back now.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("She stopped for a moment, her heart hammering in her chest. She’d come up several flights of service stairs and now saw what looked like a staff elevator. All ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Aneesa hoped for was that it would take her somewhere far away from that courtyard and somewhere quiet, where she could assess the situation she now found herself in. She longed for fresh air, and her clothes felt more constrictive than ever.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The elevator slid silently upwards, and then came to a smooth halt. The doors opened with a muted whoosh and she found herself in what looked like a utility room. Albeit a very plush utility room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She approached the one door and opened it with her heart in her mouth. Peering out she could see that she was in a suite of rooms that went on and on. All was quiet and still. No one was here. She automatically assumed that she’d found one of the empty suites in this massive hotel. Heaving a huge sigh of relief, she emerged more fully and walked into a darkened kitchen. She could see a huge formal dining room and, through that, wall-to-wall sliding glass doors which led to an open terrace and balcony outside. She could see the skyline of Mumbai laid out like a glittering carpet. This was no ordinary suite, this was the penthouse!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she thought of her own honeymoon suite with its king-size bed covered in rose petals she felt clammy and sweaty all over again. Almost tripping in her long sari she made for the glass doors, struggling to open them and get out to the fresh air.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Finally they slid back and Aneesa stumbled out, gasping now. She ripped the heavy garland of flowers from around her neck and let it fall to the ground. She was vaguely aware of a dim light coming from nearby but barely registered it. When she reached the wall she tipped her head back and breathed deep, the chaotic ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("sounds of the crazy Mumbai traffic drifting up from far, far below.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her heart finally started to slow down. So when she heard a deep drawling voice say, ‘Please don’t tell me you’re thinking of jumping…’ Aneesa screamed.")])])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a51a38e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459212077_ch01.vue
// module id = 75
// module chunks = 0